<template>
	<div class="deal_index_box">
		<!-- 個人資訊》操作記錄 -->
		<div class="deal_title">
			<div>個人資訊<span>》</span>操作記錄</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 内容 -->
		<div class="deal_content_box">
			<div class="deal_content_title">操作記錄</div>
			<div class="deal_content">
				<div class="deal_content_tab">
					<div class="deal_content_tab_first">
						<!-- 訂單列表查詢 -->
						<el-form label-width="110px">
							<el-form-item class="datetime_box" label="操作執行時間：">
								<el-date-picker value-format="timestamp" v-model="dateValue" @change="getTime" type="daterange" align="center"
								 unlink-panels range-separator="到" start-placeholder="開始日期 " end-placeholder="結束日期 " :picker-options="pickerOptions">
								</el-date-picker>
								<span class="deal_content_span">查詢期日不可超過31天</span>
							</el-form-item>

							<!-- 查询按钮 -->
							<el-form-item label="操作執行人員：">
								<el-col :span="7">
									<el-input class="form_mail_input" type="text" v-model="username" placeholder="請輸入執行人員"></el-input>
								</el-col>
								<el-col :span="8">
									<el-button type="primary" @click="ajksbtn()">查詢</el-button>
								</el-col>
							</el-form-item>
							<!-- <div class="datetime_box">
						<span>操作執行人員：</span>
						<el-select v-model="endtime" placeholder="全部">
							<el-option
							  v-for="item in options"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select> -->

						</el-form>
						<!-- 表单 -->
						<div class="table_download">
							<span>匯出紀錄</span>
							<span @click="btnster()"><img src="../../../../assets/img/login/logindeal/icon_xls.png" alt=""></span>
							<span @click="btnstertxt()"><img src="../../../../assets/img/login/logindeal/icon_txt.png" alt=""></span>
						</div>
						<div>
							<!-- 表单头 -->
							<div class="table_header">
								<div class="table_date">時間戳記</div>
								<div class="table_merchantorder">執行人員</div>
								<div class="table_paymentorder">登入IP</div>
								<div class="table_paymenttype">參考地區</div>
								<div class="table_status">頁面</div>
								<div class="table_operation">動作</div>
							</div>
							<!-- 表单内容 -->
							<div class="table_content" v-for="item of stlrData[page-1]" :key="item.id">
								<div class="table_date">{{item.starttime}}</div>
								<div class="table_merchantorder">{{item.username}}</div>
								<div class="table_paymentorder">{{item.ip}}</div>
								<div class="table_paymenttype">{{item.city}}</div>
								<div class="table_money"></div>
								<div class="table_money"></div>
							</div>
							<!-- 表单分页列表 -->
							<div class="table_pagination">
								<el-pagination @next-click="handleSizeChange" @prev-click="handleClick" @current-change="handleCurrentChange"
								 :current-page="page" :page-sizes="[10]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
								 :total="total.length">
								</el-pagination>
							</div>
						</div>

					</div>

				</div>
			</div>
		</div>
		<!-- deal_index_box -->
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDealIndex',
		data() {
			return {
				activeName: "first",
				// 日期
				formBank: [],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一個月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				exporttxt:'exporttxt',
				exportexcel: 'exportexcel',
				loat: false,
				dateValue: '',
				username: '',
				tableData: [],
				stlrData: [],
				paymentValue: '',
				transactionValue: '',
				money1: '',
				money2: '',
				end_time: '',
				start_time: '',
				list: null, //请求回来填充表格的数据   
				total: [], //数据总条数 
				page: 1, //默认显示第1页
				limit: 10 //默认一次显示10条数据
				// return
			}
		},

		methods: {
			// 查詢
			ajksbtn() {
				if (this.username == "" && this.start_time == "") {
					this.$message({
						showClose: true,
						message: '請選擇查詢參數',
						type: 'error',
						duration: 1000
					})
					return
				}
				axios.get(this.$store.state.axiosOperateUrl, {
					params: {
						username: this.username,
						start_time: this.start_time,
						end_time: this.end_time,
						action: 1,
						uid: this.$store.state.uid
					}
				}).then((res) => {
					// console.log(res.data);
					if (res.data.message) {
						this.total = res.data.message
						this.tableData = res.data.message
						this.stlrData = this.pagesrc(10)
						this.loat = true
					}


				})

			},
			// 下載xls
			btnster() {
				var xlx_url = this.$store.state.axiosxlsUrl+'&end_time='+ this.end_time+'&start_time='+this.start_time+'&username='+this.username+'&action=1'+'&uid='+this.$store.state.uid+'&do='+this.exportexcel
				window.location.href = xlx_url;
// 				if (this.loat == true) {
// 					axios.get(this.$store.state.axiosxlsUrl, {
// 						params: {
// 							end_time: this.end_time,
// 							start_time: this.start_time,
// 							username: this.username,
// 							action: 1,
// 							uid: this.$store.state.uid,
// 							do: this.exportexcel,

// 						}
// 					}).then((res) => {
// // 						this.total = res.data.message
// // 						this.tableData = res.data.message
// // 						this.stlrData = this.pagesrc(10)

// 					})
// 				} else {
// 					console.log(1)
// 					axios.get(this.$store.state.axiosxlsUrl, {
// 						params: {
// 							action: 1,
// 							uid: this.$store.state.uid,
// 							do: this.exportexcel,

// 						}
// 					}).then((res) => {
// // 						this.total = res.data.message
// // 						this.tableData = res.data.message
// // 						this.stlrData = this.pagesrc(10)

// 					})
// 					// 					console.log(this.$store.state.axiosxlsUrl)
// 					// 					var urls = this.$store.state.axiosxlsUrl;
// 					// 					window.window.location.href = urls
// 				}


			},
			// 下載txt
			btnstertxt() {
				var txt_url = this.$store.state.axiosxlsUrl+'&end_time='+ this.end_time+'&start_time='+this.start_time+'&username='+this.username+'&action=1'+'&uid='+this.$store.state.uid+'&do='+this.exporttxt
				window.location.href = txt_url;
				// if (this.loat == true) {
				// 	console.log(this.$store.state.axiosxlsUrl)
				// 	axios.get(this.$store.state.axiosxlsUrl, {
				// 		params: {
				// 			end_time: this.end_time,
				// 			start_time: this.start_time,
				// 			username: this.username,
				// 			action: 1,
				// 			uid: this.$store.state.uid,
				// 			do: this.exporttxt,
				// 		}
				// 	}).then((res) => {

				// 	})
				// } else {
				// 	console.log(2)
				// 	axios.get(this.$store.state.axiosxlsUrl, {
				// 		params: {
				// 			action: 1,
				// 			uid: this.$store.state.uid,
				// 			do: this.exporttxt,
				// 		}
				// 	}).then((res) => {


				// 	})
				// }

			},
			handleSizeChange(val) {
				this.page = this.page + 1;
			},
			handleClick(val) {
				//console.log(`当前页: ${val}`);
				this.page = this.page - 1;
			},
			handleCurrentChange(val) {
				this.page = val;
				console.log(this.page);
			},
			pagesrc(number) {
				var pages = []
				if (this.tableData) {
					this.tableData.forEach((item, index) => {
						var page = Math.floor(index / number)
						if (!pages[page]) {
							pages[page] = []
						}
						pages[page].push(item)
						this.page = page

					})
					return pages;

				}


			},
			// 上傳時間戳
			getTime() {
				if (this.dateValue[0] < this.dateValue[1]) {
					this.end_time = this.dateValue[1].toString(),
						this.end_time = this.end_time.substring(0, 10)
					this.start_time = this.dateValue[0].toString()
					this.start_time = this.start_time.substring(0, 10)

				} else {
					this.$message({
						showClose: true,
						message: '開始時間不能小於結束時間',
						type: 'error',
						duration: 1000
					})
				}

			},


		},
		mounted() {
			// 頁面加載讀取表單
			axios.get(this.$store.state.axiosOperateUrl, {
				params: {
					action: 1,
					uid: this.$store.state.uid,
				}
			}).then((res) => {
				this.total = res.data.message
				this.tableData = res.data.message
				this.stlrData = this.pagesrc(10)

			})


		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 交易管理》交易订单 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		min-height: 500px;
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}

	.money_box span {
		margin: 0 10px;
	}

	.money_input {
		width: 140px;
		/* margin-left: 4px; */
	}

	.money_input01 {
		margin-left: 4px;
	}

	.inquire_button {
		padding: 10px 0;
	}

	/* 表单 */
	.table_download {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.table_download span {
		display: inline-block;
		margin: 0 10px;
	}

	/* 表单头 */
	.table_header {
		height: 36px;
		line-height: 36px;
		background: #f2f2f2;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_content {
		padding: 10px 0;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.table_date {
		box-sizing: border-box;
		width: 160px;
		padding-left: 14px;
		padding-right: 10px;
	}

	.table_merchantorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymentorder {
		box-sizing: border-box;
		word-break: break-all;
		word-wrap: break-word;
		width: 200px;
		min-width: 160px;
		padding: 0 10px;
		min-width: 160px;
	}

	.table_paymenttype {
		box-sizing: border-box;
		width: 98px;
		padding: 0 10px;
		min-width: 77px;
	}

	.table_status {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	.table_money {
		box-sizing: border-box;
		width: 100px;
		padding: 0 10px;
		min-width: 66px;
	}

	/* .table_content .table_money {
        text-align: right;
    } */
	.table_operation {
		padding: 0 10px;
	}

	.table_operation span {
		margin-right: 10px;
		padding-bottom: 2px;
		border-bottom: 1px solid;
	}

	/* 分页 */
	.table_pagination {
		display: flex;
		margin: 20px;
		justify-content: flex-end;
	}
</style>
